import { EventEmitter, Injectable, Output } from '@angular/core';
import { Vip } from '@hungryhungry/kafka-schema';
import { LRUCache } from 'lru-cache';
import { Subscription } from 'rxjs';
import { Order } from 'src/app/models/order.model';
import { AnalyticsService } from '../../utils/analytics/analytics.service';
import { BffService } from '../../utils/comms/bff/bff.service';
import { OMBffSocketEventType, SocketioService } from '../../utils/comms/socketio/socketio.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class VipService {
  /** The subscription for VIP Orders */
  private _vipOrdersSub: Subscription;
  private readonly vips: LRUCache<string, Vip.VIP>;

  @Output() vipsUpdatedEvent: EventEmitter<null> = new EventEmitter();

  constructor(
    public socketIO: SocketioService,
    public auth: AuthService,
    public analytics: AnalyticsService,
    public bffService: BffService,
  ) {
    this.vips = new LRUCache({ max: 1000 });
  }

  public init(): void {
    this.reset();
    this.initSocketIO();
  }

  public initSocketIO() {
    this._vipOrdersSub = this.socketIO.on(OMBffSocketEventType.VIP).subscribe((vip: Vip.VIP[]) => {
      this.analytics.trackEvent('Insights data received', `${vip[0].email}, ${Date.now()}`, this.auth.Tracking_key);
      this.vips.set(vip[0].email, vip[0]);
      this.vipsUpdatedEvent.emit();
    });
  }

  /**
   * Check whether a order is a VIP customer
   * @param email orders email address
   */
  public checkIsEmailVip(email: string) {
    return this.vips.has(email);
  }

  public checkOrderForVip(order: Order): boolean {
    if (this.checkIsEmailVip(order.customer.email)) {
      return true;
    }

    if (order.batch_customers) {
      for (let index = 0; index < order.batch_customers.length; index++) {
        const customer = order.batch_customers[index];
        if (this.checkIsEmailVip(customer.email)) {
          return true;
        }
      }
    }
    return false;
  }

  public loadVips(accountId: string) {
    this.bffService.refreshVipInsights(accountId);
  }

  public reset(): void {
    if (this._vipOrdersSub) this._vipOrdersSub.unsubscribe();
    this.vips.clear();
  }

  public cleanRefresh(accountId: string) {
    this.vips.clear();
    this.loadVips(accountId);
    this.vipsUpdatedEvent.emit();
  }
}
